import { atom } from 'recoil';
import { persistAtomAtSession } from 'modules/persistAtom';

/** 로그인한 유저 정보 */
export const UserInfoAtom = atom({
  key: 'UserInfoAtom',
  default: null,
  effects: [
    persistAtomAtSession({
      key: 'UserInfoAtom'
    })
  ]
});
